import { visit } from 'unist-util-visit';

var rehypeIgnore = function rehypeIgnore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$openDelimite = options.openDelimiter,
      openDelimiter = _options$openDelimite === void 0 ? 'rehype:ignore:start' : _options$openDelimite,
      _options$closeDelimit = options.closeDelimiter,
      closeDelimiter = _options$closeDelimit === void 0 ? 'rehype:ignore:end' : _options$closeDelimit;
  return function (tree) {
    visit(tree, function (node, index, parent) {
      if (node.type === 'element' || node.type === 'root') {
        // const start = node.children.findIndex((item) => item.type === 'comment' && item.value === openDelimiter);
        // const end = node.children.findIndex((item) => item.type === 'comment' && item.value === closeDelimiter);
        // if (start > -1 && end > -1) {
        //   node.children = node.children.filter((_, idx) => idx < start || idx > end);
        // }
        var start = false;
        node.children = node.children.filter(function (item) {
          if (item.type === 'comment' && item.value.trim() === openDelimiter) {
            start = true;
            return false;
          }

          if (item.type === 'comment' && item.value.trim() === closeDelimiter) {
            start = false;
            return false;
          }

          return !start;
        });
      }
    });
  };
};

export default rehypeIgnore;